import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';

export const TableStyled = styled.table`
  ${({ theme }) => {
    return css`
      border: ${rem(1)} solid ${theme.colors.neutral.black};
    `;
  }}
`;

export const TDStyled = styled.td`
  ${({ theme }) => {
    let minWidth = rem(100);
    const largeUp = theme.largeUp();
    const mediumUp = theme.mediumUp();
    if(largeUp){
      minWidth = rem(145);
    }else if(mediumUp){
      minWidth = rem(130);
    }

    return css`
      border: ${rem(1)} solid ${theme.colors.neutral.black};
      min-width: ${minWidth};
    `;
  }}
`;

export const THeadStyled = styled.thead`
  text-align: left;
  text-weight: bold;
`;

export const SpanStyledPrintOnly = styled.span`
  display: none;
  @media print {
    display: inline !important;
  }
`;
